import { ROOT_GLOBAL } from "../../global/root";
import { initTrackMenu } from "../../utils/track";

const $ = window.$;

export const setUpMenu = () => {
  initTrackMenu();
  $(".uk-box form a").attr("href", ROOT_GLOBAL.UK_POPUP);
}

export const navActive = () => {
  switch (window.location.pathname) {
    case "/classification":
    case "/classification/":
      $(".menu-navigation .menu-body .nav-item.classification").addClass("active");
      break;
    case "/trade-advisory":
    case "/trade-advisory/":
      $(".menu-navigation .menu-body .nav-item.trade-advisory").addClass("active");
      break;
    case "/duty-tax-calculation":
    case "/duty-tax-calculation/":
      $(".menu-navigation .menu-body .nav-item.duty-tax-calculation").addClass("active");
      break;
    case "/intergration":
    case "/intergration/":
      $(".menu-navigation .menu-body .nav-item.intergration").addClass("active");
      break;
    case "/your-plan":
    case "/your-plan/":
      $(".menu-navigation .menu-body .nav-item.your-plan").addClass("active");
      break;
    case "/payments":
    case "/payments/":
      $(".menu-navigation .menu-body .nav-item.payments").addClass("active");
      break;
    case "/profile-management":
    case "/profile-management/":
      $(".menu-navigation .menu-body .nav-item.profile-management").addClass("active");
      break;
    case "/team-management":
    case "/team-management/":
      $(".menu-navigation .menu-body .nav-item.team-management").addClass("active");
      break;
    default:
      break;
  }
}

navActive();